import { CONST } from '@/utils/constants'
import Vue from 'vue'

export const Type = (type) => ({
  Workspace: Vue.i18n.translate('Workspace'),
  Grid: Vue.i18n.translate('Grid'),
  Chart: Vue.i18n.translate('Chart'),
  Metric: Vue.i18n.translate('Metric'),
  User: Vue.i18n.translate('User'),
  Group: Vue.i18n.translate('Group'),
  Discussion: Vue.i18n.translate('Discussion'),
  Trigger: Vue.i18n.translate('Trigger'),
  Distribution: Vue.i18n.translate('Distribution'),
})[type] || null

export const Access = (access) => ({
  FullAccess: Vue.i18n.translate('access fullaccess'),
  ReadOnly: Vue.i18n.translate('access readonly'),
  Locked: Vue.i18n.translate('access locked')
})[access] || null

export const DateTime = (() => {
  const notAvailable = '—'
  const formatter = (timestamp, format) => {
    const moment = parseInt(timestamp)
    return (moment > 0) ? new Date(moment).toLocaleDateString(Vue.i18n.locale(), format) : notAvailable
  }
  const Short = (timestamp) => formatter(timestamp, { day: '2-digit', month: '2-digit', year: '2-digit' })
  const Regular = (timestamp) => formatter(timestamp, { day: 'numeric', month: 'short', year: 'numeric' })
  const Long = (timestamp) => formatter(timestamp, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })
  return {
    Short,
    Regular,
    Long
  }
})()

export const Formatters = {
  Type,
  Access,
  DateTime,
}

export default Formatters
